import React from "react";
import Lottie from "react-lottie";
import "./Success_lottie.css";

function Success_lottie({ animationData }) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData, // 👈 from props
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <section className="Success_lottie">
      <div className="Success_lottie_animation">
        <Lottie className="me-auto" options={defaultOptions} />
      </div>
    </section>
  );
}

export default Success_lottie;
